import React from 'react';
import { Box, Typography } from '@mui/material';
import { COLOR, FUENTE } from './tokens';

/**
 * Reemplazo de un gráfico de tendencia cuando hay menos de 2 períodos con datos: una
 * sola línea (o una sola barra apilada) no tiene nada con qué compararse, así que se
 * muestra como cifra(s) simple(s) en vez de forzar un gráfico vacío de comparación.
 * Usado por TendenciaMensual, ConversionMensualChart y TendenciaPorTipoChart.
 * @param {{items: Array<{etiqueta: string, valor: string, color?: string}>}} props
 */
const PeriodoUnicoKpi = ({ items }) => (
    <Box sx={{ display: 'grid', gridTemplateColumns: `repeat(${Math.min(items.length, 4)}, minmax(0, 1fr))`, gap: '12px' }}>
        {items.map((it) => (
            <Box key={it.etiqueta} sx={{ background: '#F8FAFC', border: '1px solid #F1F5F9', borderRadius: '10px', padding: '14px' }}>
                <Typography sx={{ fontFamily: FUENTE, fontSize: 24, fontWeight: 700, color: it.color || COLOR.negro, fontVariantNumeric: 'tabular-nums' }}>
                    {it.valor}
                </Typography>
                <Typography sx={{ fontFamily: FUENTE, fontSize: 11.5, fontWeight: 600, color: COLOR.grisTexto, marginTop: '2px' }}>
                    {it.etiqueta}
                </Typography>
            </Box>
        ))}
    </Box>
);

export default PeriodoUnicoKpi;
